import Button from '@klv/atoms/button';
import Icon from '@klv/atoms/icon';

import { camelCaseToTitleCase, generateClassName } from '@klv/shared/utils/functions';
import { bulletTypes } from '@klv/molecules/bulleted-list-item/utils/variables';

import * as styles from './styles/bulletedListItem.module.scss';

import type { TIconName } from '@klv/atoms/icon/types';
import type { IListItem, TBulletType } from './types';

const splitName = ({ join = '', name, split = '-' }: { join?: string; name: string; split?: string; }) => {
  const nameSegments = name.split(split);
  const capitalizedNameSegments = nameSegments.map((segment) => (camelCaseToTitleCase(segment)));

  return capitalizedNameSegments.join(join);
};

const Bullet = ({ bulletType }: { bulletType?: TBulletType; }) => {
  if (bulletType) {
    const bulletA11yText = splitName({ join: ' ', name: bulletType });
    const iconName = bulletTypes.includes(bulletType) ? `${splitName({ name: `${bulletType}-bullet` })}` : '';

    return iconName ? (
      <div className={styles.bulletWrapper}>
        <Icon aria-label={bulletA11yText} fillColor='currentColor' iconName={iconName as TIconName} size={1.9} />
      </div>
    )
      : null;
  }

  return null;
};

const ListItem = ({
  bulletType,
  className,
  colorVariant = 'dark',
  itemCopy,
  itemHeading,
  itemLink,
  itemNewWindow,
  ...rest
}: IListItem) => (
  <li className={generateClassName(['listItem', className, styles.itemWrapper, styles[colorVariant] ])} role="listitem" {...rest}>
    <Bullet bulletType={bulletType} />
    {(itemHeading || itemCopy) && (
      <div className={styles.itemText}>
        {itemHeading && (
          <>
            {
              itemLink ? (
                <div>
                  <Button 
                    url={itemLink}
                    openInNewTab={itemNewWindow}
                    variant='tertiary'
                    buttonColor={colorVariant}
                    text={itemHeading}
                  />
                </div>
              ) : (
                <div className={generateClassName(['p2', 'semibold'])}>
                  {itemHeading}
                </div>
              )
            }
          </>
        )}
        
        {itemCopy && (
          <div className='p2' dangerouslySetInnerHTML={{ __html: itemCopy }} />
        )}
      </div>
    )}
  </li>
);

export default ListItem;
